import Phaser from 'phaser'
import Editable from './editable'
import ObstacleEditor from '../editor/obstacleEditor'
import Platform from './platform'
import Obstacle from './obstacle'

export default class RepeatingObstacleManager extends Editable {
  constructor (scene, args, doSave = true) {
    super(scene, args, 'rObs', doSave)

    this.image = this.scene.matter.add.image(args.x, args.y, 'obs_gun')
    this.image.setTint(this.scene.colorFG)
    this.image.setIgnoreGravity(true)
    this.image.setSensor(true)
    this.image.setDepth(7)
    this.image.parentContainer = this
    this.image.setCollisionGroup(this.scene.collisionGroup1)
    this.image.setCollisionCategory(this.scene.collisionCategory2)

    this.nObstacles = args.nObstacles || 2
    this.addEditableProperty('nObstacles', (value) => { this.setNObstacles(value) }, () => { return this.nObstacles })

    this.spawnObstacles()

    this.countdown = args.countdown || 6
    this.addEditableProperty('countdown', (value) => { this.setCountdown(value) }, () => { return this.countdown })
    this.countDownTimer = 0.01

    this.speed = args.speed
    this.addEditableProperty('speed', (value) => { this.setSpeed(value) }, () => { return this.speed })

    this.speedX = args.speedX || 0
    this.addEditableProperty('speedX', (value) => { this.setSpeedX(value) }, () => { return this.speedX })

    this.init(args, true)
    this.refreshImage()
  }

  spawnObstacles () {
    this.obstacles = []
    for (var i = 0; i < this.nObstacles; i++) {
      var def = { type: 'obs', data: { x: this.image.x, y: this.image.y, width: 100, height: 100, noHeight: true } }
      var pl = this.scene.spawner.spawnFromDef(def, false, false)
      pl.image.setFriction(0, 0, 0)
      pl.hide()
      pl.hideEditing()
      this.obstacles.push(pl)
    }

    this.lastObstacleIndex = 0
    // this.countDownTimer = 0.0
  }

  setNObstacles (value) {
    // destroy all old platforms
    for (var i = 0; i < this.nObstacles; i++) {
      this.scene.levelEditor.deleteObject(this.obstacles[i])
    }

    this.nObstacles = value

    // and create a bunch of new ones
    this.spawnObstacles()
  }

  setCountdown (value) {
    this.countdown = value
    this.countDownTimer = 0.01
  }

  setSpeed (value) {
    this.speed = value
    this.refreshImage()
  }

  setSpeedX (value) {
    this.speedX = value
    this.refreshImage()
  }

  preUpdate (time, delta) {
    super.preUpdate(time, delta)

    this.countDownTimer -= delta * 0.001
    if (this.countDownTimer <= 0) {
      this.countDownTimer = this.countdown

      this.obstacles[this.lastObstacleIndex].image.x = this.image.x
      this.obstacles[this.lastObstacleIndex].image.y = this.image.y
      // this.obstacles[this.lastObstacleIndex].image.setScale(this.image.scaleX, this.image.scaleY)
      this.obstacles[this.lastObstacleIndex].image.setVelocity(this.speedX, -1 * this.speed)

      this.obstacles[this.lastObstacleIndex].show()
      this.lastObstacleIndex++
      if (this.lastObstacleIndex >= this.obstacles.length) {
        this.lastObstacleIndex = 0
      }
    }
  }

  showEditing () {
    super.showEditing()
    // this.show()
    for (var i = 0; i < this.nObstacles; i++) {
      this.obstacles[i].hideEditing()
    }
  }

  hideEditing () {
    super.hideEditing()
    // this.hide()
  }

  refreshImage () {
    if (this.speedX > 0) {
      this.image.setAngle(90)
    } else if (this.speedX < 0) {
      this.image.setAngle(270)
    } else if (this.speed < 0) {
      this.image.setAngle(180)
    } else {
      this.image.setAngle(0)
    }
  }
/*
  hide () {
    this.image.setVisible(false)
    this.square.setVisible(false)

    this.image.setCollisionGroup(this.scene.collisionGroupNO_COLL)
    this.image.setCollisionCategory(this.scene.collisionCatNO_COLL)
    this.square.setCollisionGroup(this.scene.collisionGroupNO_COLL)
    this.square.setCollisionCategory(this.scene.collisionCatNO_COLL)
  }

  show () {
    this.image.setVisible(true)
    // this.square.setVisible(true)

    this.image.setCollisionGroup(this.scene.collisionGroup1)
    this.image.setCollisionCategory(this.scene.collisionCategory2)
    // this.square.setCollisionGroup(this.scene.collisionGroup1)
    // this.square.setCollisionCategory(this.scene.collisionCategory2)
  } */
}
